import React from "react";
import { Check } from "lucide-react";

// Shared building blocks for the Account (profile) page and its sections.

export const inputCls =
  "h-11 w-full px-3.5 bg-slate-50/90 border border-slate-200 rounded-xl text-sm text-slate-800 outline-none transition-all shadow-sm focus:border-s360-violet focus:ring-4 focus:ring-s360-violet/10 placeholder:text-slate-400";

export const Field = ({ label, optional, children, className = "" }) => (
  <div className={`flex flex-col gap-1.5 ${className}`}>
    <label className="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500">
      {label}
      {optional && <span className="ml-1.5 font-normal lowercase tracking-normal text-slate-400">optional</span>}
    </label>
    {children}
  </div>
);

export const SavedChip = ({ show }) =>
  show ? (
    <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-1 text-[11px] font-semibold text-emerald-700">
      <Check className="h-3.5 w-3.5" /> Saved
    </span>
  ) : null;

// Reusable section card with an iconed header. Renders as a <form> when onSubmit
// is supplied, otherwise a plain container.
export const SectionCard = ({ title, desc, icon: Icon, action, onSubmit, children, tone = "violet" }) => {
  const toneClasses =
    tone === "teal"
      ? {
          icon: "bg-[#E9FBF7] text-[#0F766E]",
          border: "border-[#DFF6F1]",
          accent: "from-s360-teal to-s360-violet",
        }
      : {
          icon: "bg-s360-violet-50 text-s360-violet",
          border: "border-[#EAF2F1]",
          accent: "from-s360-violet to-s360-teal",
        };

  const headerRight = action;
  const body = (
    <>
      <div className={`border-b ${toneClasses.border} px-5 py-4 sm:px-6`}>
        <div className="flex items-center justify-between gap-3">
          <div className="flex min-w-0 items-center gap-3">
            {Icon && (
              <span
                className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl ${toneClasses.icon}`}
              >
                <Icon className="h-[18px] w-[18px]" />
              </span>
            )}
            <div className="flex min-w-0 flex-col">
              <h3 className="m-0 truncate text-[15px] font-semibold text-slate-900">{title}</h3>
              {desc && <span className="truncate text-xs text-slate-500">{desc}</span>}
            </div>
          </div>
          {headerRight}
        </div>
      </div>
      {children}
    </>
  );

  if (onSubmit)
    return (
      <form
        onSubmit={onSubmit}
        className="flex flex-col overflow-hidden rounded-[24px] border border-slate-200/80 bg-white shadow-[0_20px_55px_-35px_rgba(15,23,42,0.45)]"
      >
        <div className={`h-1.5 w-full bg-gradient-to-r ${toneClasses.accent}`} />
        {body}
      </form>
    );
  return (
    <div className="flex flex-col overflow-hidden rounded-[24px] border border-slate-200/80 bg-white shadow-[0_20px_55px_-35px_rgba(15,23,42,0.45)]">
      <div className={`h-1.5 w-full bg-gradient-to-r ${toneClasses.accent}`} />
      {body}
    </div>
  );
};
